"use client"
import { useState, useEffect } from "react"
import { Snackbar, Alert } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import { Box, Typography } from "@mui/material"
import CssBaseline from "@mui/material/CssBaseline"
import AdminLayout from "./components/Layout/AdminLayout"
import VendorLayout from "./components/VendorLayout/VendorLayout"
import Dashboard from "./pages/Dashboard"
import VendorDashboard from "./pages/VendorDashboard"
import Settings from "./pages/Settings"
// HRM
import SupplierManage from "./pages/HRM/SupplierManage"
import CustomerManage from "./pages/HRM/CustomerManage"
import NationalSalesManager from "./pages/HRM/NationalSalesManager"
import RegionalManager from "./pages/HRM/RegionalManager"
import AreaManager from "./pages/HRM/AreaManager"
import MPOManage from "./pages/HRM/MPOManage"
import EmployeeManage from "./pages/HRM/EmployeeManage"
import EmployeeAttendance from "./pages/HRM/EmployeeAttendance"
// Sales
import SaleManage from "./pages/Sales/SaleManage" // Import SaleManage
import SaleOrderManage from "./pages/Sales/SaleOrderManage" // Import SaleManage
import SalesReportsPage from "./pages/Sales/SalesReportsPage" // Import SaleManage
import CustProDateSalesReport from "./pages/SalesReport/CustProDateSalesReport" // Import SaleManage
import CustProSalesReport from "./pages/SalesReport/CustProSalesReport" // Import SaleManage
import CustDateSalesReport from "./pages/SalesReport/CustDateSalesReport" // Import SaleManage
import ProLifeTimeSalesReport from "./pages/SalesReport/ProLifeTimeSalesReport" // Import SaleManage
import ProDateSalesReport from "./pages/SalesReport/ProDateSalesReport" // Import SaleManage
import DateRangeSalesReport from "./pages/SalesReport/DateRangeSalesReport" // Import SaleManage
import DateSalesPayDueReport from "./pages/SalesReport/DateSalesPayDueReport" // Import SaleManage
import SalesReportTestPage from "./pages/SalesReport/SalesReportTestPage" // Import SaleManage

// Accounts
import PaymentReceive from "./pages/Accounts/PaymentReceive" // Import SaleManage
import PaymentReceiveReport from "./pages/Accounts/PaymentReceiveReport" // Import SaleManage
import TeamWisePaymentReport from "./pages/PaymentReport/TeamWisePaymentReport" // Import SaleManage

// Manufactures
import RawMaterial from "./pages/Manufactures/RawMaterial"
import PurchasePlanManage from "./pages/Manufactures/PurchasePlanManage"
import PurchaseManage from "./pages/Manufactures/PurchaseManage"
import PurchaseOrderManage from "./pages/Manufactures/PurchaseOrderManage"
import PurchasesReportsPage from "./pages/Manufactures/PurchasesReportsPage"


// Admin
import AllAdmin from "./pages/Admin/AllAdmin"
import AddAdmin from "./pages/Admin/AddAdmin"
import EditAdmin from "./pages/Admin/EditAdmin"
import AllMultiAdmin from "./pages/Admin/AllMultiAdmin"
import AddMultiAdmin from "./pages/Admin/AddMultiAdmin"
import DatabaseBackupPage from "./pages/Admin/DatabaseBackupPage"

// Role And Permission
import AllPermission from "./pages/Role&Permission/AllPermission"
import AddPermission from "./pages/Role&Permission/AddPermission"
import EditPermission from "./pages/Role&Permission/EditPermission"
import AllRole from "./pages/Role&Permission/AllRole"
import AddRole from "./pages/Role&Permission/AddRole"
import EditRole from "./pages/Role&Permission/EditRole"


import RolePermissionAssign from "./pages/Role&Permission/RolePermissionAssign"
import AllRolePermission from "./pages/Role&Permission/AllRolePermission"
import EditRolePermissionAssign from "./pages/Role&Permission/EditRolePermissionAssign"

// Permission hook

import React from "react";
import Can from "./components/Can";
import { PermissionProvider } from "./context/PermissionContext";

// Mount and Placeholder
import MyComponent from "./pages/mount/MyComponent" // Import SaleManage
import ParentComponent from "./pages/mount/ParentComponent" // Import SaleManage
import PlaceholderPage from "./pages/PlaceholderPage"

// Authentication Components
import Login from "./components/Auth/Login"
import ForgotPassword from "./components/Auth/ForgotPassword"
import ResetPassword from "./components/Auth/ResetPassword"
import Register from "./components/Auth/Register"
import EmailVerified from "./components/Auth/EmailVerified"
import Logout from "./components/Auth/Logout"
import AdminProfile from "./pages/AdminProfile";
import ChangePassword from "./pages/ChangePassword";

import VendorProfile from "./pages/VendorProfile";
import VendorChangePassword from "./pages/VendorChangePassword";

import axios from "axios"
import BaseURL from './api/AppURL';
import ProfileContext from "./contexts/ProfileContext"; // import context


// Material UI Theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
      light: "#42a5f5",
      dark: "#1565c0",
    },
    secondary: {
      main: "#dc004e",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
    success: {
      main: "#4CAF50",
      contrastText: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffffff",
          borderRight: "1px solid #e0e0e0",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#333333",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: "rgba(76, 175, 80, 0.8)", // #4CAF50 এর RGB মান (76, 175, 80) এবং 0.8 অপাসিটি
          color: "#FFFFFF",
        },
        icon: {
          color: "#FFFFFF !important",
        },
      },
    },
  },
})

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("auth_token"))
  const [loadingAuth, setLoadingAuth] = useState(true)

  // permission hook


  const getInitialProfile = () => {
    const stored = localStorage.getItem("profile");
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch {
        // fallback if JSON fails
        return {
          name: "Admin User",
          email: "admin@company.com",
          photo: "",
        }
      }
    }
    return {
      name: "Admin User",
      email: "admin@company.com",
      photo: "",
    };
  };

  const [profile, setProfile] = useState(getInitialProfile());


  useEffect(() => {
    localStorage.setItem("profile", JSON.stringify(profile));
  }, [profile]);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  // onSaveSuccess handler যা Snackbar খুলবে মেসেজ সহ
  const handleSaveSuccess = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };


  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("auth_token")
      if (token) {
        try {
          const response = await axios.get(`${BaseURL}/user`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          if (response.status === 200) {
            setIsLoggedIn(true)
          } else {
            localStorage.removeItem("auth_token")
            setIsLoggedIn(false)
          }
        } catch (error) {
          console.error("Token validation failed:", error)
          localStorage.removeItem("auth_token")
          setIsLoggedIn(false)
        }
      } else {
        setIsLoggedIn(false)
      }
      setLoadingAuth(false)
    }
    checkAuth()
  }, [])

  const handleLogin = () => {
    setIsLoggedIn(true)
  }

  const handleLogout = () => {
    const token = localStorage.getItem("auth_token")
    axios
      .post(
        `${BaseURL}/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then(() => {
        localStorage.removeItem("auth_token")
        setIsLoggedIn(false)
      })
      .catch((err) => {
        console.error("Logout error:", err)
        localStorage.removeItem("auth_token")
        setIsLoggedIn(false)
      })
  }

  if (loadingAuth) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h5" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <ProfileContext.Provider value={{ profile, setProfile }}>
        <PermissionProvider>
          <CssBaseline />
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/email-verified" element={<EmailVerified />} />
              <Route path="/logout" element={<Logout onLogout={handleLogout} />} />
              {/* Protected Routes */}

              <Route path="/*" element={isLoggedIn ? <AdminLayout onLogout={handleLogout} /> : <Navigate to="/login" />}>
                <Route index element={<Dashboard />} />
                <Route path="admin/dashboard" element={<Dashboard />} />
                <Route path="admin/profile" element={<AdminProfile onSaveSuccess={handleSaveSuccess} />} />
                <Route path="admin/change-password" element={<ChangePassword onSaveSuccess={handleSaveSuccess} />} />
                

                {/* Accounts Routes */}

                <Route path="accounts/account-report" element={<PlaceholderPage title="Account Report" />} />
                <Route path="accounts/profit-calculation" element={<PlaceholderPage title="Profit Calculation" />} />
                <Route path="accounts/expense-manage" element={<PlaceholderPage title="Expense Manage" />} />
                <Route path="accounts/deposit-manage" element={<PlaceholderPage title="Deposit Manage" />} />
                <Route path="accounts/salary-manage" element={<PlaceholderPage title="Salary Manage" />} />
                <Route path="accounts/payment-receive" element={<PaymentReceive title="Payment Receive" />} />
                <Route path="accounts/payment-out" element={<PlaceholderPage title="Payment Out" />} />
                <Route path="accounts/payment-rec-report" element={<PaymentReceiveReport title="Payment Receive Report" />} />
                <Route path="accounts/payment-out-report" element={<PlaceholderPage title="Payment Out Report" />} />
                <Route path="accounts/team_wise-payment" element={<TeamWisePaymentReport title="Team Wise Payment Report" />} />


                {/* Balance Sheet Routes */}
                <Route path="balance-sheet/loan-receive" element={<PlaceholderPage title="Loan Receive" />} />
                <Route path="balance-sheet/loan-pay" element={<PlaceholderPage title="Loan Pay" />} />
                <Route path="balance-sheet/fixed-assets" element={<PlaceholderPage title="Fixed Assets" />} />
                <Route path="balance-sheet/fa-purchase" element={<PlaceholderPage title="FA Purchase" />} />
                <Route path="balance-sheet/report" element={<PlaceholderPage title="Balance Sheet Report" />} />
                {/* Test Routes */}
                <Route path="mount/my-component" element={<MyComponent title="My Component" />} />
                <Route path="mount/parent" element={<ParentComponent title="This is Parent Component" />} />
                {/* Sales Routes */}
                <Route path="sales/order-manage" element={<SaleOrderManage title="Order Manage" />} />
                <Route path="sales/sale-manage" element={<SaleManage />} /> {/* Updated to SaleManage */}
                <Route path="sales/all-sales-reports" element={<SalesReportsPage title="All Sales Reports" />} />
                <Route path="all/salereportrangespecific" element={<CustProDateSalesReport title="All Sales Reports" />} />
                <Route path="all/custprosalesreport" element={<CustProSalesReport title="Cust Pro Sales Report" />} />
                <Route path="all/custdatesalesreport" element={<CustDateSalesReport title="Cust Pro Sales Report" />} />
                <Route path="all/proltsalesrReport" element={<ProLifeTimeSalesReport title="Pro Life Time Sales Report" />} />
                <Route path="all/prodatesalesreport" element={<ProDateSalesReport title="Pro Date Sale Report" />} />
                <Route path="all/daterangesalesreport" element={<DateRangeSalesReport title="Pro Date Sale Report" />} />
                <Route path="all/datesalespayduereport" element={<DateSalesPayDueReport title="Date Sales Pay Due Report" />} />
                <Route path="all/salereporttestpage" element={<SalesReportTestPage title="All Sales Reports" />} />
                {/* Manufactures Routes */}
                <Route path="manufacture/raw-material" element={<RawMaterial title="Order Manage" />} />
                <Route path="manufacture/raw-purchase-plan" element={<PurchasePlanManage title="Order Manage" />} />
                <Route path="manufacture/raw-purchase-order" element={<PurchaseOrderManage title="Order Manage" />} />
                <Route path="manufacture/purchase-raw-material" element={<PurchaseManage />} /> {/* Updated to SaleManage */}
                <Route path="purchases/raw-purchases-reports" element={<PurchasesReportsPage title="All Purchases Reports" />} />
                {/* HRM Routes */}

                <Route path="hrm/supplier-manage" element={<SupplierManage />} />
                <Route path="hrm/customer-manage" element={<CustomerManage />} />
                <Route path="hrm/national-sales-manager" element={<NationalSalesManager />} />
                <Route path="hrm/regional-manager" element={<RegionalManager />} />
                <Route path="hrm/area-manager" element={<AreaManager />} />
                <Route path="hrm/mpo-manage" element={<MPOManage />} />
                <Route path="hrm/employee-manage" element={<EmployeeManage />} />
                <Route path="hrm/employee-attendance" element={<EmployeeAttendance />} />
                {/* Manufacture Routes */}
                <Route path="manufacture/raw-materials" element={<PlaceholderPage title="Raw Materials" />} />
                <Route path="manufacture/raw-purchase-plan" element={<PlaceholderPage title="Raw Purchase Plan" />} />
                <Route path="manufacture/raw-purchase-order" element={<PlaceholderPage title="Raw Purchase Order" />} />
                <Route
                  path="manufacture/purchase-raw-material"
                  element={<PlaceholderPage title="Purchase RawMaterial" />}
                />
                <Route path="manufacture/raw-purchase-report" element={<PlaceholderPage title="Raw Purchase Report" />} />
                <Route
                  path="manufacture/raw-material-stock-report"
                  element={<PlaceholderPage title="RawMaterial Stock Report" />}
                />
                <Route
                  path="manufacture/raw-category-wise-stock"
                  element={<PlaceholderPage title="Raw Category Wise Stock" />}
                />
                <Route path="manufacture/manufacture-manage" element={<PlaceholderPage title="Manufacture Manage" />} />
                <Route path="manufacture/packaging-manage" element={<PlaceholderPage title="Packaging Manage" />} />
                <Route path="manufacture/finished-good-stock" element={<PlaceholderPage title="Finished Good Stock" />} />
                <Route
                  path="manufacture/production-cost-analysis"
                  element={<PlaceholderPage title="Production Cost Analysis" />}
                />
                {/* Product Routes */}
                <Route path="product/product-manage" element={<PlaceholderPage title="Product Manage" />} />
                <Route path="product/purchase-product" element={<PlaceholderPage title="Purchase Product" />} />
                <Route path="product/purchase-order" element={<PlaceholderPage title="Purchase Order" />} />
                <Route path="product/stock-manage" element={<PlaceholderPage title="Stock Manage" />} />
                <Route path="product/production-report" element={<PlaceholderPage title="Production Report" />} />
                <Route path="product/product-stock-report" element={<PlaceholderPage title="Product Stock Report" />} />
                {/* Reports Routes */}
                <Route path="reports/sales" element={<PlaceholderPage title="Sales Reports" />} />
                <Route path="reports/purchase" element={<PlaceholderPage title="Purchase Reports" />} />
                <Route path="reports/inventory" element={<PlaceholderPage title="Inventory Reports" />} />


                {/* Role And Permission */}
                <Route path="admin/all_permission" element={<AllPermission />} />
                <Route path="admin/add_permission" element={<AddPermission />} />
                <Route path="admin/edit-permission/:id" element={<EditPermission />} />

                <Route path="admin/all_role" element={<AllRole />} />
                <Route path="admin/add_role" element={<AddRole />} />
                <Route path="admin/edit-role/:id" element={<EditRole />} />


                <Route path="admin/add_role_permission" element={<RolePermissionAssign />} />
                <Route path="admin/all_role_permission" element={<AllRolePermission />} />
                <Route path="admin/edit-role-permission/:id" element={<EditRolePermissionAssign />} />

                {/* Admin Routes */}
                <Route path="admin/all_admin" element={<AllAdmin />} />
                <Route path="admin/add_admin" element={<AddAdmin />} />
                <Route path="admin/edit-admin/:id" element={<EditAdmin />} />
                <Route path="admin/all_multi_admin" element={<AllMultiAdmin />} />
                <Route path="admin/add_multi_admin" element={<AddMultiAdmin />} />
                <Route path="admin/database_backup" element={<DatabaseBackupPage />} />


                {/* Settings Route */}
                <Route path="settings" element={<Settings />} />
                {/* Catch-all for undefined routes within AdminLayout */}
                <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
              </Route>


              <Route path="/*" element={isLoggedIn ? <VendorLayout onLogout={handleLogout} /> : <Navigate to="/login" />}>
                <Route path="amanager/dashboard" element={<VendorDashboard />} />
                <Route path="amanager/profile" element={<VendorProfile onSaveSuccess={handleSaveSuccess} />} />
                <Route path="amanager/change-password" element={<VendorChangePassword onSaveSuccess={handleSaveSuccess} />} />


                <Route path="*" element={<Navigate to="/vendor/dashboard" replace />} />
              </Route>
            </Routes>
          </Router>
        </PermissionProvider>
        {/* Snackbar UI */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        //  sx={{ mt: '-4px', mr: '16px' }}  
        >
          <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </ProfileContext.Provider>
    </ThemeProvider>
  )
}
export default App
